module.exports = __webpack_public_path__ + "static/media/online.d3e1e61b.svg";